import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { IMG_CAMINHO } from 'src/app/app.api';
import { Planta } from 'src/app/shared/model/planta.model';
import { DataService } from 'src/app/shared/service/data.service';

@Component({
  selector: 'dom436-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {

  plantas: Planta[];
  caminhoImg: string = null;

  carouselOptions: OwlOptions = {
    items: 1,
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 700,
    nav: true,
    navText:["<div class='nav-btn prev-slide'><img alt='Seta' src='assets/images/arrow-left-black.svg' /></div>","<div class='nav-btn next-slide'><img alt='Seta' src='assets/images/arrow-right-black.svg' /></div>"],
    autoplay: true,
    autoWidth: true,
    autoHeight: true,
    responsive: {
      0: {
        items: 1 
      }
    },
  }

  constructor(
    private dataService: DataService,
    private route: ActivatedRoute,
  ) {
    this.dataService.listPlantas()
      .subscribe(plantas => {
        this.plantas = plantas;
      });
  }

  ngOnInit(): void {
    let corretorParam = this.route.snapshot.queryParams['corretor'];
    if(corretorParam) {
      this.dataService.getIpAddress()
        .subscribe((res:any) => {
          let userIp = res.ip;
          this.dataService.getCorretorByCodigoUrl(corretorParam, userIp)
            .subscribe(corretor => {
              if(corretor) {
                sessionStorage.setItem('selectedCorretor', JSON.stringify(corretor));
              }
            });
        });
    }
    this.caminhoImg = IMG_CAMINHO;
  }

  @ViewChild('h1Title') h1TitleElement: ElementRef;
  @ViewChild('detailsElement') detailsElement: ElementRef;
  @ViewChild('galleryElement') galleryElement: ElementRef;
  @ViewChild('galleryTitleElement') galleryTitleElement: ElementRef;
  @ViewChild('galleryContentElement') galleryContentElement: ElementRef;
  @ViewChild('apartmentsElement') apartmentsElement: ElementRef;
  @ViewChild('apartmentsTitleElement') apartmentsTitleElement: ElementRef;
  @ViewChild('apartmentsContentElement') apartmentsContentElement: ElementRef;
  @ViewChild('locationElement') locationElement: ElementRef;
  @ViewChild('locationTitleElement') locationTitleElement: ElementRef;
  @ViewChild('locationContentElement') locationContentElement: ElementRef;
  @ViewChild('aboutElement') aboutElement: ElementRef;
  @ViewChild('bannerElement') bannerElement: ElementRef;
  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.bannerElement.nativeElement.style.transform = `translateY(${window.pageYOffset * 1}px)`;
    if((window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) > this.galleryElement.nativeElement.offsetTop - ((this.galleryElement.nativeElement.offsetTop/100)*100)) {
      window.dispatchEvent(new Event('resize')); // Fix para o recarregamento do carousel
      this.galleryContentElement.nativeElement.classList.add('animate__animated');
      this.galleryContentElement.nativeElement.classList.add('animate__fadeIn');
      this.galleryContentElement.nativeElement.classList.add('open');
      //this.galleryElement.nativeElement.style.transform = `translateY(${window.pageYOffset * 1}px)`;
    } else if((window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) <= this.galleryElement.nativeElement.offsetTop - ((this.galleryElement.nativeElement.offsetTop/100)*80)) {
      this.galleryContentElement.nativeElement.classList.remove('animate__animated');
      this.galleryContentElement.nativeElement.classList.remove('animate__fadeIn');
      this.galleryContentElement.nativeElement.classList.remove('open');
    }
    if((window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) >= this.galleryElement.nativeElement.offsetTop) {
      this.galleryTitleElement.nativeElement.classList.add('sticky-title');
      this.bannerElement.nativeElement.style.transform = `translateY(0px)`;
    } else if((window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) < this.galleryElement.nativeElement.offsetTop) {
      this.galleryTitleElement.nativeElement.classList.remove('sticky-title');
    }
    if((window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) > this.apartmentsElement.nativeElement.offsetTop - ((this.apartmentsElement.nativeElement.offsetTop/100)*10)) {
      this.apartmentsContentElement.nativeElement.classList.add('animate__animated');
      this.apartmentsContentElement.nativeElement.classList.add('animate__fadeIn');
      this.apartmentsContentElement.nativeElement.classList.add('open');
    } else if((window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) <= this.apartmentsElement.nativeElement.offsetTop - ((this.apartmentsElement.nativeElement.offsetTop/100)*11)) {
      this.apartmentsContentElement.nativeElement.classList.remove('animate__animated');
      this.apartmentsContentElement.nativeElement.classList.remove('animate__fadeIn');
      this.apartmentsContentElement.nativeElement.classList.remove('open');
    }
    if((window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) >= this.apartmentsElement.nativeElement.offsetTop) {
      this.galleryTitleElement.nativeElement.classList.remove('sticky-title');
      this.apartmentsTitleElement.nativeElement.classList.add('sticky-title');
      //this.galleryElement.nativeElement.style.transform = `translateY(0px)`;
    } else if((window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) < this.apartmentsElement.nativeElement.offsetTop) {
      this.apartmentsTitleElement.nativeElement.classList.remove('sticky-title');
    }
    if((window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) > this.locationElement.nativeElement.offsetTop - ((this.locationElement.nativeElement.offsetTop/100)*10)) {
      this.locationContentElement.nativeElement.classList.add('animate__animated');
      this.locationContentElement.nativeElement.classList.add('animate__fadeIn');
      this.locationContentElement.nativeElement.classList.add('open');
    } else if((window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) <= this.locationElement.nativeElement.offsetTop - ((this.locationElement.nativeElement.offsetTop/100)*11)) {
      this.locationContentElement.nativeElement.classList.remove('animate__animated');
      this.locationContentElement.nativeElement.classList.remove('animate__fadeIn');
      this.locationContentElement.nativeElement.classList.remove('open');
    }
    if((window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) >= this.locationElement.nativeElement.offsetTop) {
      this.galleryTitleElement.nativeElement.classList.remove('sticky-title');
      this.apartmentsTitleElement.nativeElement.classList.remove('sticky-title');
      this.locationTitleElement.nativeElement.classList.add('sticky-title');
      //this.galleryElement.nativeElement.style.transform = `translateY(0px)`;
    } else if((window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) < this.locationElement.nativeElement.offsetTop) {
      this.locationTitleElement.nativeElement.classList.remove('sticky-title');
    }
    if((window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) >= this.aboutElement.nativeElement.offsetTop) {
      this.galleryTitleElement.nativeElement.classList.remove('sticky-title');
      this.apartmentsTitleElement.nativeElement.classList.remove('sticky-title');
      this.locationTitleElement.nativeElement.classList.remove('sticky-title');
    }
  }

  navegarApartamentos() {
    this.galleryContentElement.nativeElement.classList.add('open'); // Necessário para abrir corretamente o #apartamentos
  }

  navegarLocalizacao() {
    this.locationContentElement.nativeElement.classList.add('open'); // Necessário para abrir corretamente o #localizacao
  }

  voltarTopo() {
    window.scrollTo(0, 0);
  }
}
